module.exports = __webpack_public_path__ + "img/天蠍座.3acbba37.svg";